<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25.0001"
      r="16.5"
      transform="rotate(45 25 25.0001)"
      fill="#4D4E58"
      stroke="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.0711 19.1077L30.8926 17.9292L25 23.8217L19.1074 17.9292L17.9289 19.1077L23.8215 25.0002L17.9289 30.8928L19.1074 32.0713L25 26.1788L30.8926 32.0713L32.0711 30.8928L26.1785 25.0002L32.0711 19.1077Z"
      fill="white"
    />
  </svg>
</template>
